import $ from "jquery";
import "slick-carousel";

$(".quote-slider .quote-slides").slick({
  infinite: true,
  fade: true,
  autoplay: true,
  autoplaySpeed: 5000
});
